import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { getPersonalQueriesByFaqId } from "../../../api/FAQ/Admin/PersonalFAQ/getPersonalQueriesByFaqId";
import UserPersonalReplySc from "./index.sc";
import { useParams } from "react-router-dom";
import { useAuthContext } from "../../../hooks";
import { createPersonalQueryResponse } from "../../../api/FAQ/Admin/PersonalFAQ/Response/createPersonalQueryResponse";
import { getQuereyByResponseQueryId } from "../../../api/FAQ/Admin/PersonalFAQ/Response/getQuereyByResponseQueryId";
function Index() {
  const params = useParams();
  const auth = useAuthContext();
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();
  const [personalQId, setPersonalQId] = useState<any>([]);
  const fetchAllAnonymousFaq = async () => {
    await getPersonalQueriesByFaqId(auth?.userInfo?.orgs[0]?.id, params?.faqId)
      .then((e) => {
        console.log(e);
        setPersonalQId(e);
      })
      .catch((e) => console.log(e));
  };
  const [responseQuery, setResponseQuery] = useState<any>([]);
  const fetchResponseQueryId = async () => {
    await getQuereyByResponseQueryId(auth?.userInfo?.orgs[0]?.id, params?.faqId)
      .then((e) => {
        console.log(e);
        setResponseQuery(e);
      })
      .catch((e) => console.log(e));
  };
  useEffect(() => {
    fetchAllAnonymousFaq();
    fetchResponseQueryId();
  }, []);
  const handleCreatePersonalResponse = async (e: any) => {
    console.debug("data > ", e);
    await createPersonalQueryResponse(
      auth?.userInfo?.orgs[0]?.id,
      (auth?.userInfo?.orgs_user_id[0]).toString(),
      params?.faqId,
      {
        ...e,
        re_org_user_id: auth?.userInfo?.orgs_user_id[0],
      }
    )
      .then((e) => {
        console.log(e);
      })
      .catch((err) => {
        console.log("====================================");
        console.log(err);
        console.log("====================================");
      });
  };
  console.log(auth?.userInfo?.orgs_user_id[0]);
  const onSubmit = async (e: any) => {
    console.log("I am Here", e);
    await handleCreatePersonalResponse(e);
    reset();
  };
  return (
    <UserPersonalReplySc>
      <div className="container_reply">
        {personalQId?.map((data: any) => {
          return (
            <>
              <div className="heading">
                <div className="member_name">
                  Employee Name{""}:{""}
                  <span style={{ fontSize: "15px", margin: "10px" }}>
                    {data?.posted_by}
                  </span>
                </div>
                <div className="faq_type">
                  Created at {""}:{data?.created_at}
                </div>
              </div>
              <div className="query_content">{data?.query}</div>
            </>
          );
        })}
        <label>Response</label>
        <div className="admin_reply_container">
          {responseQuery?.map((data: any) => {
            return (
              <>
                <div>{data?.pfr_response}</div>
              </>
            );
          })}
        </div>

        <div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <label>Reply </label>
            <textarea
              {...register("response", {
                required: {
                  value: true,
                  message: "This is required",
                },
              })}
            ></textarea>
            <div className="response_tab">
              <Button className="submit_button" type="submit">
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </UserPersonalReplySc>
  );
}

export default Index;
